import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '01', label: 'Dinheiro' },
			{ value: '03', label: 'Crédito' },
			{ value: '04', label: 'Débito' },
			{ value: '15', label: 'Boleto' },
			{ value: '16', label: 'Depósito' },
			{ value: '17', label: 'Pix' },
			{ value: '18', label: 'Transferência' },
			{ value: '90', label: 'Sem Pagamento' },
			{ value: '99', label: 'Outros' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

